import React from 'react';
import { useController } from 'react-hook-form';
import { formatDefaultValueSelect } from '../../utils/mask';
import {
  FormSelect,
  FormInputLabel,
  FormItemContainer,
} from '../StyledComponents';

export const DEFAULT_VALUE_SELECIONE = 'UF';

const SelectUfPratif = ({
  name,
  control,
  rules,
  placeholder,
  onChangeDefault,
  onPress,
  notRequired = false,
  requiredColor = '#0061C6',
  options,
  capitalize,
  defaultName,
  defaultValue,
  ...props
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name, rules });

  const renderError = () =>
    error && error.message ? (
      <p
        style={{
          color: error?.message ? '#F5365C' : '#000000',
        }}
      >
        {error?.message}
      </p>
    ) : null;

  const capitalizeText = (option) => {
    return capitalize
      ? formatDefaultValueSelect(option?.sigla || option?.nome || option)
      : option?.sigla || option?.nome || option;
  };

  return (
    <FormItemContainer width="4.2rem" left="1rem" top="1rem">
      <FormInputLabel>
        <label>
          {placeholder}{' '}
          {!notRequired && <strong style={{ color: requiredColor }}>*</strong>}
        </label>
      </FormInputLabel>
      <FormSelect
        {...props}
        value={value}
        placeholder={placeholder}
        onChange={(event) => {
          if (onChangeDefault) onChangeDefault(event.target.value);
          onChange(event.target.value);
        }}
      >
        <option value={defaultValue}>{defaultName}</option>
        {options?.map((option) => (
          <option
            value={option.id}
            title={option?.sigla || option?.nome || option}
          >
            {capitalizeText(option)}
          </option>
        ))}
      </FormSelect>
      {renderError()}
    </FormItemContainer>
  );
};

export default SelectUfPratif;
